export default `
varying vec2 vUv;

uniform float uNmColumns;
uniform float uNmLines;
uniform sampler2D uTextureMain;
uniform sampler2D uMainPosition;

float circle(vec2 uv, float border) {
    float radius = 0.5;
    float dist = radius - distance(uv, vec2(.5));
    return smoothstep(0.0, border, dist);
}

void main() {
    // Determine the size of each sub-region in the texture
    vec2 gridSize = vec2(1.0 / (uNmColumns+1.), 1.0 / (uNmLines+1.));

    // Determine the UV offset for this particle based on vUv
    vec2 uvOffset = ((vUv) * vec2(uNmColumns, uNmLines)) * gridSize;

    // Map gl_PointCoord to the correct region of the texture
    vec2 uv = uvOffset + vec2(gl_PointCoord.x, 1. - gl_PointCoord.y) * gridSize;

    // Sample the texture with the new UV coordinates
    vec4 color = texture2D(uTextureMain, uv);

    vec2 position = texture2D(uMainPosition, vUv).xy;

    // Define the center of the circular reveal
    vec2 center = vec2(0.0, 0.0);

    // Define the inner and outer radii for the reveal
    float innerRadius = 0.5;
    float outerRadius = 0.8;

    // Calculate the distance from the particle to the center
    float distanceToCenter = length(position - center);

    // Calculate the alpha based on the distance of the particle from the center
    float alphaFactor = smoothstep(outerRadius, innerRadius, distanceToCenter);

    // Apply the calculated alpha factor to the color's alpha channel
    color.a *= alphaFactor;

    gl_FragColor = color;
}
`;
//# sourceMappingURL=fragment.js.map